import React, {Component} from 'react';
import Styles from './style.css';
import cx from 'classnames';
import {langRegister} from "../../../services/langRegister";
import {marketRegister} from "../../../services/marketRegister";
import {salesChannelRegister} from "../../../services/salesChannelRegister";

class HomeSectionsTwelve extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: []
        };
    };

    componentWillMount() {
        this._updateItems()
    }

    _updateItems() {
        let items = [];
        if (salesChannelRegister.get("market") === "ae") {
            items = [
                {
                    status: "Hairdresser",
                    name: "andrea",
                    text: "Easy to use and instant traffic to my business. I’m very happy with the service as I had no previous experience with paid ads. I’m happy to recommend the service\n"
                },
                {
                    status: "Agent",
                    name: "ali",
                    text: "I was recommended this service from my client, it’s very intuitive and easy to use. I really appreciate the price transparency, I only pay for what I get. All the best!"
                }
            ];
        } else {
            items = [
                {
                    status: langRegister.lang() === "sv" ? "Bilverkstad" :  "Car repair shop",
                    name: "anders",
                    text: langRegister.lang() === "sv" ? "Kul tjänst om man snabbt vill komma igång med annonser på nätet. Vi fick en hel del förfrågningar trots en relativt liten budget. Vi har planerat in fler kampanjer " : "Easy service if you want to get started with ads online. We received many inquiries despite a relatively small budget. We have scheduled more campaigns"
                },
                {
                    status: langRegister.lang() === "sv" ? "Städfirma" : "Cleaning company",
                    name: "sara",
                    text: langRegister.lang() === "sv" ? "Vi har provat lite olika konsulter och tjänster men har äntligen hittat rätt – enkelt, snabbt och smart. Man slipper allt onödig trassel och betalar rimliga pengar!" : "We have tried some different consultants and services but have finally found it - easy, fast and smart. Skip all unnecessary hassles and pay reasonable money!"
                }
            ];
        }
        this.setState({items: items});
    }

    _renderText(item) {
        return langRegister.get("home-sections-twelve", item);
    }

    render() {
        return (
            <div className={Styles.section}>
                <div className={Styles.container}>
                    <div className={Styles.title}>
                        {this._renderText("item_1")}
                    </div>
                    <div className={Styles.items}>
                        {
                            this.state.items.map((item) => {
                                return (
                                    <div className={Styles.item}>
                                        <div className={Styles.itemBackground}>
                                            <div className={Styles.itemBackgroundOverlay}>
                                                <div className={Styles.itemBackgroundOverlayTop}>
                                                    <img className={Styles.itemBackgroundOverlayTopIcon}
                                                         src={require("../../../assets/images/AB_client_new.png")}/>
                                                    <div className={Styles.itemBackgroundOverlayTopText}>
                                                        <div className={Styles.itemBackgroundOverlayTopStars}>
                                                            <img className={Styles.itemBackgroundOverlayTopStarsIcon}
                                                                 src={require("../../../assets/images/star_icon.png")}/>
                                                            <img className={Styles.itemBackgroundOverlayTopStarsIcon}
                                                                 src={require("../../../assets/images/star_icon.png")}/>
                                                            <img className={Styles.itemBackgroundOverlayTopStarsIcon}
                                                                 src={require("../../../assets/images/star_icon.png")}/>
                                                            <img className={Styles.itemBackgroundOverlayTopStarsIcon}
                                                                 src={require("../../../assets/images/star_icon.png")}/>
                                                            <img className={Styles.itemBackgroundOverlayTopStarsIcon}
                                                                 src={require("../../../assets/images/star_icon.png")}/>
                                                        </div>
                                                        <div className={Styles.itemBackgroundOverlayTopTextStatus}>
                                                            {item.status}
                                                        </div>
                                                        <div className={Styles.itemBackgroundOverlayTopTextName}>
                                                            {item.name}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={Styles.itemBackgroundOverlayBottom}>
                                                    {item.text}
                                                </div>
                                                <div className={Styles.itemBackgroundOverlayQuote}>
                                                    "
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default HomeSectionsTwelve;


// WEBPACK FOOTER //
// ./src/components/home-sections/twelve/component.js